import { useSyncExternalStore } from 'react';

import isMobile from 'is-mobile';

export function useMobile() {
  const isMobileDevice = useSyncExternalStore(subscribe, isMobile);
  return isMobileDevice;
}

function subscribe(callback: () => void) {
  globalThis.addEventListener('resize', callback);
  return () => {
    globalThis.removeEventListener('resize', callback);
  };
}
